export default "__VITE_ASSET__CyqkNAxY__"